import React from 'react';
import styles from './GreenButton.module.scss';

interface IGreenButtonProps {
    children: React.JSX.Element | string;
    onClick?: () => void;
    outline?: boolean;
    disabled?: boolean;
    noMargin?: boolean;
    mini?: boolean;
}

export const GreenButton = ({ children, onClick, outline, disabled = false, noMargin, mini }: IGreenButtonProps) => {
    const buttonClasses = [styles.greenButton];
    if (outline) buttonClasses.push(styles.outline);
    if (noMargin) buttonClasses.push(styles.noMargin);
    if (disabled) buttonClasses.push(styles.disabled);
    if (mini) buttonClasses.push(styles.mini);
    return (
        <div
            onClick={() => {
                if (!disabled && onClick) onClick();
            }}
            className={buttonClasses.join(' ')}
        >
            {children}
        </div>
    );
};
